<template>
    <div class="abilityDetails">

        <!-- 标题 -->
        <div class="title">功能疗养院</div>
        <div class="empty"></div>
        <div class="content">

            <!-- 三行文字 -->
            <topText :title="title" :subtitle="subtitle"></topText>

            <!-- 按钮 -->
            <div class="btns">
                <div v-for="(item, index) in dataList" :key="index"
                >
                    <button :class="{active:isActive===index}" >{{ item }}</button>
                </div>
                <input type="text" placeholder="输入您想改善的问题">
                <div class="horizontalline"></div>
            </div>
            <!-- 最下面按钮 -->
            <button class="immediate">立即改善</button>
        </div>
    </div>
</template>

<script>
import topText from './components/topText.vue'
export default {
  name: 'Recuperation',
  components: {
    topText
  },
  data () {
    return {
      dataList: ['呼吸系统', '内分泌系统', '消化系统', '免疫系统', '骨骼系统', '神经系统',
        '泌尿系统', '生殖系统', '心血管系统', '五官系统', '循环系统'],
      title: '功能疗养院',
      subtitle: '提升器官自愈能力',
      isActive: 2
    }
  },
  methods: {

  },
  mounted () {
  },
  computed: {

  }
}
</script>

<style lang="scss" scoped>
.abilityDetails {
    // height: 100%;
    background:linear-gradient( rgba(175, 131, 255, 0.5) 100%, rgba(153,102,255, 0.5)100%),url("https://gotocloud8-open-sx.oss-cn-hangzhou.aliyuncs.com/www/HealthingCore/recuperation.png");
    background-size: 100%;
    background-color: #FFF;
    color: #4f4f4f;
    font-size: 23px;

    .title {
        text-align: center;
        color: #fff;
        padding: 20px;
    }

    .empty {
        width: 150px;
        height: 18px;
        background: #FF8563;
        border-radius: 10px;
        margin: 160px 10px 0 120px;
    }

    .content {
        width: 100%;
        border-radius: 30px;
        background: #fff;
        margin-top: -10px;
        color: #808080;

        .btns {
            margin: 12px;
            font-size: 17px;
            display: flex;
            flex-wrap: wrap;

            button,
            input {
                width: 160px;
                height: 40px;
                margin: 10px 0 10px 10px;
                border-radius: 20px;
                border: 1px solid #ccc;
                background: #F7F8F8;
            }
            .active{
                background: #FFCEC7
            }

            .horizontalline {
                width: 300px;
                border-bottom: 2px dashed;
                margin: 30px 20px;
            }
        }

        .immediate {
            width: 180px;
            height: 60px;
            margin: 10px 100px;
            font-size: 25px;
            border: 1px solid #ccc;
            border-radius: 30px;
            background: #ffaa8f;
            color: #fff;
        }
    }
}
</style>
